import { render, staticRenderFns } from "./list-collection-complete-btn.vue?vue&type=template&id=c64ae316&"
import script from "./list-collection-complete-btn.vue?vue&type=script&lang=js&"
export * from "./list-collection-complete-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports